/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PageInfoDto } from '../models/page-info-dto';
import { reviewAdminControllerCreateV1 } from '../fn/review-admin/review-admin-controller-create-v-1';
import { ReviewAdminControllerCreateV1$Params } from '../fn/review-admin/review-admin-controller-create-v-1';
import { reviewAdminControllerDeleteV1 } from '../fn/review-admin/review-admin-controller-delete-v-1';
import { ReviewAdminControllerDeleteV1$Params } from '../fn/review-admin/review-admin-controller-delete-v-1';
import { reviewAdminControllerFindAllV1 } from '../fn/review-admin/review-admin-controller-find-all-v-1';
import { ReviewAdminControllerFindAllV1$Params } from '../fn/review-admin/review-admin-controller-find-all-v-1';
import { reviewAdminControllerFindByIdV1 } from '../fn/review-admin/review-admin-controller-find-by-id-v-1';
import { ReviewAdminControllerFindByIdV1$Params } from '../fn/review-admin/review-admin-controller-find-by-id-v-1';
import { reviewAdminControllerReorderV1 } from '../fn/review-admin/review-admin-controller-reorder-v-1';
import { ReviewAdminControllerReorderV1$Params } from '../fn/review-admin/review-admin-controller-reorder-v-1';
import { reviewAdminControllerSearchCursorV1 } from '../fn/review-admin/review-admin-controller-search-cursor-v-1';
import { ReviewAdminControllerSearchCursorV1$Params } from '../fn/review-admin/review-admin-controller-search-cursor-v-1';
import { reviewAdminControllerSearchOffsetV1 } from '../fn/review-admin/review-admin-controller-search-offset-v-1';
import { ReviewAdminControllerSearchOffsetV1$Params } from '../fn/review-admin/review-admin-controller-search-offset-v-1';
import { reviewAdminControllerUpdateV1 } from '../fn/review-admin/review-admin-controller-update-v-1';
import { ReviewAdminControllerUpdateV1$Params } from '../fn/review-admin/review-admin-controller-update-v-1';
import { ReviewDto } from '../models/review-dto';

@Injectable({ providedIn: 'root' })
export class ReviewAdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `reviewAdminControllerFindAllV1()` */
  static readonly ReviewAdminControllerFindAllV1Path = '/api/v1/reviews/admin';

  /**
   * 후기 전체 조회 (관리자).
   *
   * 후기 전체를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reviewAdminControllerFindAllV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  reviewAdminControllerFindAllV1$Response(params?: ReviewAdminControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ReviewDto>>> {
    const obs = reviewAdminControllerFindAllV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 후기 전체 조회 (관리자).
   *
   * 후기 전체를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reviewAdminControllerFindAllV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reviewAdminControllerFindAllV1(params?: ReviewAdminControllerFindAllV1$Params, context?: HttpContext): Observable<Array<ReviewDto>> {
    const resp = this.reviewAdminControllerFindAllV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ReviewDto>>): Array<ReviewDto> => r.body)
    );
  }

  /** Path part for operation `reviewAdminControllerCreateV1()` */
  static readonly ReviewAdminControllerCreateV1Path = '/api/v1/reviews/admin';

  /**
   * 후기 생성.
   *
   * 후기를 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reviewAdminControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reviewAdminControllerCreateV1$Response(params: ReviewAdminControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ReviewDto>> {
    const obs = reviewAdminControllerCreateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 후기 생성.
   *
   * 후기를 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reviewAdminControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reviewAdminControllerCreateV1(params: ReviewAdminControllerCreateV1$Params, context?: HttpContext): Observable<ReviewDto> {
    const resp = this.reviewAdminControllerCreateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ReviewDto>): ReviewDto => r.body)
    );
  }

  /** Path part for operation `reviewAdminControllerSearchOffsetV1()` */
  static readonly ReviewAdminControllerSearchOffsetV1Path = '/api/v1/reviews/admin/search/offset';

  /**
   * 후기 오프셋 기반 조회 (관리자).
   *
   * 후기를 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reviewAdminControllerSearchOffsetV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  reviewAdminControllerSearchOffsetV1$Response(params: ReviewAdminControllerSearchOffsetV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<ReviewDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = reviewAdminControllerSearchOffsetV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 후기 오프셋 기반 조회 (관리자).
   *
   * 후기를 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reviewAdminControllerSearchOffsetV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reviewAdminControllerSearchOffsetV1(params: ReviewAdminControllerSearchOffsetV1$Params, context?: HttpContext): Observable<{
'items': Array<ReviewDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.reviewAdminControllerSearchOffsetV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<ReviewDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<ReviewDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `reviewAdminControllerSearchCursorV1()` */
  static readonly ReviewAdminControllerSearchCursorV1Path = '/api/v1/reviews/admin/search/cursor';

  /**
   * 후기 커서 기반 조회 (관리자).
   *
   * 후기를 커서 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reviewAdminControllerSearchCursorV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  reviewAdminControllerSearchCursorV1$Response(params: ReviewAdminControllerSearchCursorV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<ReviewDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
}>> {
    const obs = reviewAdminControllerSearchCursorV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 후기 커서 기반 조회 (관리자).
   *
   * 후기를 커서 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reviewAdminControllerSearchCursorV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reviewAdminControllerSearchCursorV1(params: ReviewAdminControllerSearchCursorV1$Params, context?: HttpContext): Observable<{
'items': Array<ReviewDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
}> {
    const resp = this.reviewAdminControllerSearchCursorV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<ReviewDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
}>): {
'items': Array<ReviewDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
} => r.body)
    );
  }

  /** Path part for operation `reviewAdminControllerFindByIdV1()` */
  static readonly ReviewAdminControllerFindByIdV1Path = '/api/v1/reviews/admin/{id}';

  /**
   * 후기 상세 조회 (관리자).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reviewAdminControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  reviewAdminControllerFindByIdV1$Response(params: ReviewAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ReviewDto>> {
    const obs = reviewAdminControllerFindByIdV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 후기 상세 조회 (관리자).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reviewAdminControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reviewAdminControllerFindByIdV1(params: ReviewAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<ReviewDto> {
    const resp = this.reviewAdminControllerFindByIdV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ReviewDto>): ReviewDto => r.body)
    );
  }

  /** Path part for operation `reviewAdminControllerDeleteV1()` */
  static readonly ReviewAdminControllerDeleteV1Path = '/api/v1/reviews/admin/{id}';

  /**
   * 후기 삭제.
   *
   * 후기를 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reviewAdminControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  reviewAdminControllerDeleteV1$Response(params: ReviewAdminControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ReviewDto>> {
    const obs = reviewAdminControllerDeleteV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 후기 삭제.
   *
   * 후기를 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reviewAdminControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reviewAdminControllerDeleteV1(params: ReviewAdminControllerDeleteV1$Params, context?: HttpContext): Observable<ReviewDto> {
    const resp = this.reviewAdminControllerDeleteV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ReviewDto>): ReviewDto => r.body)
    );
  }

  /** Path part for operation `reviewAdminControllerUpdateV1()` */
  static readonly ReviewAdminControllerUpdateV1Path = '/api/v1/reviews/admin/{id}';

  /**
   * 후기 수정.
   *
   * 후기를 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reviewAdminControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reviewAdminControllerUpdateV1$Response(params: ReviewAdminControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ReviewDto>> {
    const obs = reviewAdminControllerUpdateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 후기 수정.
   *
   * 후기를 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reviewAdminControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reviewAdminControllerUpdateV1(params: ReviewAdminControllerUpdateV1$Params, context?: HttpContext): Observable<ReviewDto> {
    const resp = this.reviewAdminControllerUpdateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ReviewDto>): ReviewDto => r.body)
    );
  }

  /** Path part for operation `reviewAdminControllerReorderV1()` */
  static readonly ReviewAdminControllerReorderV1Path = '/api/v1/reviews/admin/reorder';

  /**
   * 후기 순서 변경.
   *
   * 후기의 순서를 변경합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reviewAdminControllerReorderV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reviewAdminControllerReorderV1$Response(params: ReviewAdminControllerReorderV1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = reviewAdminControllerReorderV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 후기 순서 변경.
   *
   * 후기의 순서를 변경합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reviewAdminControllerReorderV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reviewAdminControllerReorderV1(params: ReviewAdminControllerReorderV1$Params, context?: HttpContext): Observable<void> {
    const resp = this.reviewAdminControllerReorderV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
